var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 632,
    height: 723,
    viewBox: "0 0 632 723",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M347.85 274.781L431.71 361.141L347.41 447.961L263.55 361.601L347.85 274.781ZM347.85 188.651L179.91 361.611L347.41 534.091L515.35 361.131L347.85 188.651Z",
    fill: "#FDC4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3499 351.191H45.3499C39.8299 351.191 35.3499 355.671 35.3499 361.191V363.191C35.3499 368.711 39.8299 373.191 45.3499 373.191H75.3499C80.8699 373.191 85.3499 368.711 85.3499 363.191V361.191C85.3499 355.671 80.8699 351.191 75.3499 351.191Z",
    fill: "#FDC4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M582.07 338.751L603.72 360.401L581.94 382.181L560.28 360.541L582.07 338.751ZM582.06 310.471L532 360.541L581.93 410.471L632 360.401L582.06 310.471Z",
    fill: "#FDC4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M350.98 42.1514C350.98 42.1514 464.36 78.4514 51.8497 368.831M351.16 683.151C351.16 683.151 464.54 646.851 52.0297 356.471M362.35 675.151C351.64 696.771 327.24 707.541 305.35 701.151C279.85 693.701 267.02 665.681 272.35 644.151C275.23 632.511 282.9 624.881 287.35 621.151M279.91 95.0813C266.54 75.0013 269.41 48.4814 285.89 32.7214C305.09 14.3614 335.77 17.2613 351.75 32.6413C360.39 40.9613 363.16 51.4114 364.17 57.1314",
    stroke: "#FDC4C4",
    strokeWidth: 40,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.918b119cac31ec8f9fac9431f2f6f10c.svg";
export { ForwardRef as ReactComponent };